<template>
  <div>
    <Alerts ref="alert"/>
    <Forms ref="frmSinisterAnalyze"
            :title="'ANALISE'"
            :showHelp="false"
            :showClearButton="hasRole(this.roles.RW_REG_TABANALYZE) && !isCompleted ? true : false"
            :showSaveButton="hasRole(this.roles.RW_REG_TABANALYZE) && !isCompleted ? true : false"
            v-on:Clear="onClear"
            v-on:Save="onSave">
        <SinisterHeader ref="SinisterHeader"/>
        <div class="form-group row">
          <div class="col-md-12 intermediate-bar"><i class="fa fa-calendar-check-o"></i>&nbsp; INFO AGENDAMENTO </div>
        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <label for="txtInstructions"> Instruções:</label>
            <b-form-textarea name="txtInstructions"
                            v-model="form.instructions.value"
                            :placeholder="$lang.Sinister.Scheduling.PlaceholderInstructions"
                            :rows="form.instructions.rows"
                            :size="form.instructions.maxlength"
                            :noResize="form.instructions.noResize"
                            :disabled="true"/>
          </div>
          <div class="col-md-6">
            <label for="txtAnalyzSpecify"> Observações:</label>
            <b-form-textarea name="txtAnalyzSpecify"
                            v-model="form.observations.value"
                            :placeholder="$lang.Sinister.Scheduling.PlaceholderEnterObservations"
                            :rows="form.observations.rows"
                            :size="form.observations.maxlength"
                            :noResize="form.observations.noResize"
                            :disabled="true"/>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <span v-if="!(this.data.urlBudgetSystem == null || this.data.urlBudgetSystem === '')">
              Para consultar o sinistro no sistema de orçamentação, <a v-bind:href="this.data.urlBudgetSystem" target="_blank">clique aqui</a>.
            </span>
          </div>
        </div>
        <div class="form-group row pt-3">
          <div class="col-md-12 intermediate-bar"><i class="fa fa-file-text-o"></i>&nbsp; DADOS DA ANÁLISE</div>
        </div>
        <div>
          <div class="form-group row">
            <div class="col-md-2">
              <label for="txtActionDateAnalyze"><small v-show="form.actionDate.required"  class="text-danger">*</small> {{$lang.Sinister.Analyze.ActionDate}}:</label>
              <div class="input-group">
                <datepicker name="txtActionDateAnalyze" v-model="form.actionDate.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
              </div>
            </div>
            <!--
            <div class="col-md-2">
              <label for="cbxTypeConclusion">Tipo de Conclusão</label>
              <div class="input-group">
                <b-form-select v-model="form.typeConclusionID.value"
                              :options="form.typeConclusionID.options"
                              :state="form.typeConclusionID.state"
                              class="mb-3"
                              name="cbxTypeConclusion"
                              :disabled="isCompleted">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Autorizado</option>
                  <option :value="2">Não autorizado</option>
                  <option :value="3">Frustrada</option>
                  <option :value="5">Não Acordo</option>
                  <option :value="4" disabled>Outros</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-2" v-show="form.typeConclusionID.value == 3">
              <label for="cbxReasonFrustration">Motivo da Frustação</label>
              <div class="input-group">
                <b-form-select v-model="form.reasonFrustration.value"
                              :options="form.reasonFrustration.options"
                              :state="form.reasonFrustration.state"
                              class="mb-3"
                              name="cbxReasonFrustration"
                              :disabled="isCompleted">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Pedido Indevido</option>
                  <option :value="2">Veículo Ausente</option>
                  <option :value="3">Orçamento em elaboração</option>
                  <option :value="5">Responsável Ausente</option>
                  <option :value="4" disabled>Realizado pela CIA</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-2" v-show="form.typeConclusionID.value != 3">
              <label for="cbxLossType">Tipo de Perda</label>
              <div class="input-group">
                <b-form-select v-model="form.lossTypeID.value"
                              :options="form.lossTypeID.options"
                              :state="form.lossTypeID.state"
                              class="mb-3"
                              name="cbxLossType"
                              :disabled="isCompleted">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Perda Parcial</option>
                  <option :value="2">Indenização Integral</option>
                </b-form-select>
              </div>
            </div>
            -->
            <div class="col-md-4">
              <label for="cbxHasNonconformityBudget"><small v-show="form.hasNonconformityBudget.required" class="text-danger">*</small>Houve alguma inconformidade no orçamento?</label>
              <div class="input-group">
                <b-form-select v-model="form.hasNonconformityBudget.value"
                              :options="form.hasNonconformityBudget.options"
                              :state="form.hasNonconformityBudget.state"
                              class="mb-3"
                              name="cbxHasNonconformityBudget"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="true">{{$lang.Common.Yes}}</option>
                  <option :value="false">{{$lang.Common.No}}</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-3" v-show="form.hasNonconformityBudget.value">
              <label for="cbxNonconformityBudgetReason">Qual inconformidade?</label>
              <div class="input-group">
                <b-form-select v-model="form.nonconformityBudgetReason.value"
                              :options="form.nonconformityBudgetReason.options"
                              :state="form.nonconformityBudgetReason.state"
                              class="mb-3"
                              name="cbxNonconformityBudgetReason"
                              :disabled="isCompleted">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Indefinição no tipo de perda (P.P. ou I.I.)</option>
                  <option :value="2">Laudos de I.I. não preenchidos</option>
                  <option :value="3">Numero do motor não fotografado ou ilegível</option>
                  <option :value="4">Fornecimento de peças fora da regra</option>
                  <option :value="5">Regra de não acordo ou DNC aplicado e informado incorretamente</option>
                  <option :value="6">Padrão de MDO e desconto aplicado incorretamente</option>
                  <option :value="7">Não houve negociação (reparação ou peças originais)</option>
                  <option :value="8">Dados e relatos não preenchidos corretamente (veículo, oficina e parecer)</option>
                  <option :value="10">Não acordo HDI</option>
                  <option :value="9">Outros</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-3">
              <label>Reagendar Vistoria?</label>
              <div class="input-group">
                <span class="input-group-addon input-group-addon-icondropdown"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                <b-form-select v-model="form.rescheduleInspection.value"
                              :options="form.rescheduleInspection.options"
                              :state="form.rescheduleInspection.state"
                              class="mb-3"
                              :disabled="isCompleted">
                  <template slot="first">
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="0">Não</option>
                  <option :value="24">Sim, em 24hs</option>
                  <option :value="48">Sim, em 48hs</option>
                  <option :value="72">Sim, em 72hs</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtAnalyzSpecify"> Especifique quais são as outras inconformidade:</label>
              <b-form-textarea name="txtAnalyzSpecify"
                              v-model="form.nonconformityBudgetDescription.value"
                              :placeholder="'Digite quais são as outras inconformidade'"
                              :rows="form.nonconformityBudgetDescription.rows"
                              :size="form.nonconformityBudgetDescription.maxlength"
                              :noResize="form.nonconformityBudgetDescription.noResize"
                              :disabled="isCompleted"/>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
            <div class="col-md-6">
              <label for="txtEmailAdm"> E-mail para o administrativo:</label>
              <b-form-textarea name="txtEmailAdm"
                              v-model="form.emailAdm.value"
                              :placeholder="'Digite informações para envio de email para o administrativo'"
                              :rows="form.emailAdm.rows"
                              :size="form.emailAdm.maxlength"
                              :noResize="form.emailAdm.noResize"
                              :disabled="isCompleted"/>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>

          <!-- Modal Return Regulation -->
          <div class="form-group row pb-3">
            <b-modal id="modal-center" v-model="isShowModalReturnRegulation" size="lg" centered title="Devolver processo para correção">
              <p class="my-4 text-center" style="font-weight:bold;font-size:15px;">Deseja devolver a versão atual do Processo para o Regulador responsável?</p>
              <div slot="modal-footer" class="w-100 text-right">
                <b-btn size="sm" variant="success" @click="updateRegulationStageToDigitation">
                  Não, enviar para Digitação
                </b-btn>

                <!-- <b-btn size="sm" variant="primary" @click="confirmReturnRegulation">
                  Sim, confirmar devolução!
                </b-btn> -->
              </div>
            </b-modal>
          </div>
        </div>
        <!--
        <div class="form-group row pb-3" v-if="hasRole(this.roles.RW_REG_TABANALYZE)" v-show="!isCompleted">
          <div class="col-md-12 text-left force-border-bottom pl-3">
            <button type="button" class="btn btn-third btn-sm" v-on:click="onSave" v-show="!isCompleted"><i class="fa fa-check-circle"></i> {{$lang.Common.Buttons.Save}} </button>&nbsp;
            <button type="button" class="btn btn-default btn-sm text-secundary" v-on:click="onClear" v-show="!isCompleted"><i class="fa fa-minus-circle"></i> {{$lang.Common.Buttons.Clear}} </button>&nbsp;
          </div>
        </div>
        -->
    </Forms>
  </div>
</template>
<script>
import sinisteranalyze from './sinisteranalyze.js'

export default sinisteranalyze
</script>
<style lang="scss" scoped>
  .vcenter-2 {
    line-height: 38px;
  }

  .vcenter-3-1 {
    line-height: 64px;
  }

  .vcenter-3-1 label {
    line-height: 38px;
  }

  .vcenter-3-2 {
    line-height: 58px;
  }

  .vcenter-3-2 label {
    vertical-align: middle;
    line-height: 28px;
  }

  .vcenter-2 input, .vcenter-2 span, .vcenter-2 label,
  .vcenter-3-1 input, .vcenter-3-1 span, .vcenter-3-1 label,
  .vcenter-3-2 input, .vcenter-3-2 span, .vcenter-3-2 label {
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/analyze/SinisterAnalyze.vue